
import { FaQuoteLeft, FaStar } from "react-icons/fa"
const TestimonialCard = ({ text, image, imagename, clientName,title }) => {
    return (
        <div className="w-[300px] h-[400px] rounded-lg shadow-lg shadow-black py-2 px-2 flex-col">
            <div className="w-full h-[50%] bg-yellow-700 rounded-lg py-2 px-2 text-justify text-sm text-white font-semibold font-serif flex justify-center items-center">
                <div>
                    <FaQuoteLeft size={10} className="text-gray-400" />
                    {text}
                </div>
            </div>
            <div className="w-full h-[50%] bg-white rounded-lg py-2 px-2  flex flex-col justify-center items-center">
                <div className="flex">
                    <FaStar size={10} className="text-yellow-500" />
                    <FaStar size={10} className="text-yellow-500" />
                    <FaStar size={10} className="text-yellow-500" />
                    <FaStar size={10} className="text-yellow-500" />
                    <FaStar size={10} className="text-yellow-500" />
                </div>
                <div className="w-12 h-12 rounded-full mb-4 ">
                    <img src={image} alt={imagename} className="w-full h-full rounded-full" />
                </div>
                <div className="text-black font-bold font-mono text-lg">
                    {clientName}
                </div>
                <div className="text-yellow-500 font-md font-semibold ">{title}</div>
            </div>
        </div>
    );
}

export default TestimonialCard;